import React, { useEffect, useRef } from 'react';
import {motion, useInView, useAnimate, useAnimation, useAnimationControls, useScroll, useTransform} from 'framer-motion';


export default function PlancoIntro() {
  return (
    <>
          <div className='w-full h-auto grid grid-cols-12 place-items-center bg-gradient-to-r from-teal-800  to-green-800'>
      <div className='md:col-start-3 md:col-end-11 col-start-2 col-end-12 grid place-items-center'>
      <motion.div initial={{ y:20 ,opacity: 0.2 }} whileInView={{ y:0, opacity: 1, transition: { duration: 1 } }} className='w-full h-auto grid grid-place-items-center bg-white/20 p-10 md:p-20 rounded-md my-10'>
              <h1 className='text-[44px] sm:text-[60px] text-white font-monda font-bold tracking-tighter w-full'>Planco</h1>
                <p className='text-[24px] font-monda text-white font-bold tracking-tighter pb-5 md:pb-10'>Redefining convetional sustainability</p>
                <div className='w-full space-y-2 pb-4'>
                  <p className='text-white text-md md:text-lg font-medium'>During my time studying with HEX Ed - a not-for-profit educational company bridging the gap between secondary-to-tertiary students and industry workers - I collaborated with a variety of mentors to understand all the crucial considerations which go into creating a competitive social enterprise. Planco - a web-based sustainability service - is the final product I created.</p>
              </div>
          </motion.div>
      </div>
    </div>
    </>
  )
}
